/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-24 16:27:51
 * @LastEditors: K
 * @LastEditTime: 2022-09-16 14:32:36
 */
import { unwrapResult } from '@reduxjs/toolkit';
import { Button, Col, Collapse, Input, Modal, ModalProps, Row, Space, Spin, Table, TableColumnType, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { ReactElement, useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import styles from './blindPersonmedical.module.css'
import { ThemeContext } from '../../../theme/ThemeContext';
import { CaretDownFilled, CaretRightFilled } from '@ant-design/icons';
import _ from 'lodash';
import { commonListAsync, commonRemoveAsync, commonSaveAsync, getTempalteDetailList, getTemplateCategoryList } from '../../template/templateSlice';
import { TemplateCategory } from '../../../models/template';
import { LikeedIcon, LikeIcon } from '../../../compnents/icons/Icons';
import { SaveTemplateModal } from '../../template/SaveTemplateModal';
import { selectUserId } from '../../../app/applicationSlice';
import { getUserProfileList } from '../../personalManagement/personalDetail/personalDetailSlice';

interface DiagnosisTemplateProps {
  templateModalVasible?: any
  targetTemplate?: any
  cancelTemplate?: () => void
  templateData?: (v?:any) => void
  setFormValues: (d: any, t?: any) => void
}

export const DiagnosisTemplate = ({
  templateModalVasible,
  targetTemplate,
  cancelTemplate,
  templateData,
  setFormValues,
}: DiagnosisTemplateProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const { Panel } = Collapse

  const dispatch = useDispatch<RootDispatch>()

  const userId = useSelector(selectUserId)

  const [templates, setTemplates] = useState<TemplateCategory[]>([])

  const [templateKeyword, setTemplateKeyword] = useState('') //查询得值

  const [recipeCollapse, setRecipeCollapse] = useState<any>([])  // 记录选中的模板

  const [templateDetails, setTemplateDetails] = useState<
    Record<string, any[]>
  >({})  // 模板详情

  const [SaveTemplateModalVasible, setSaveTemplateModalVasible] = useState(
    false
  )

  const [selectedCategoryId, setSelectedCategoryId] = useState('')

  const [loading, setLoading] = useState(false)

  const [checkData, setCheckData] = useState<any>([])

  const isWubi = checkData?.filter((v: any) => v?.code == '5')?.[0]?.codeName == 1 ? 1 : 0 
  
  useEffect(() => {
    console.log(templateModalVasible,"templateModalVasible")
    if (templateModalVasible == 'true') {
      setSaveTemplateModalVasible(true)
    }
  }, [templateModalVasible])

    // 获取个人设置权限
    useEffect(() => {
      if (userId) {
        dispatch(getUserProfileList({ userId: userId }))
          .then(unwrapResult)
          .then((c: any) => {
            setCheckData(c)
          })
      }
    }, [userId])

  // 获取模板列表
  useEffect(() => {
    dispatch(
      getTemplateCategoryList({
        current: 1,
        size: 100,
        categoryName: templateKeyword,
        medicalRecord: 2,
        isWubi: isWubi
      })
    )
      .then(unwrapResult)
      .then(async (templates) => {
        let activeId = '0'
        const data = [
          {
            categoryName: '收藏',
            id: '-1',
            medicalRecord: 2,
          },
          ...templates,
        ]
        setTemplates(data)
        templateData && templateData(data)
        const commonList = !templateDetails['-1']
          ? await dispatch(commonListAsync('2')).then(unwrapResult)
          : templateDetails['-1']
        if (commonList.length && !templateDetails['-1']) {
          activeId = '-1'
        } else {
          activeId = templates[0].id
        }
        templates.length && setSelectedCategoryId(activeId)
        _.forEach([templates[0]?.id], (id) => {
          if (!templateDetails[id]) {
            const template = templates.find((t) => t.id === id)
            if (template) {
              dispatch(getTempalteDetailList(id))
                .then(unwrapResult)
                .then((details) => {
                  setTemplateDetails({
                    ...templateDetails,
                    [id]: details,
                    ['-1']: commonList,
                  })
                })
            }
          }
        })
      })
      .catch(() => {
        // do nothing.
      })
  }, [templateKeyword])


  // 保存模板
  const like = useCallback(
    _.debounce((d) => {
      setLoading(true)
      dispatch(
        commonSaveAsync({
          itemId: d.id,
          medicalRecord: 2,
        })
      )
        .then(unwrapResult)
        .then(() => {
          onUpdateColl(d.templateId)
        })
        .catch(() => {
          setLoading(false)
        })
    }, 500),
    []
  )

  // 删除模板
  const liked = useCallback(
    _.debounce((d) => {
      dispatch(commonRemoveAsync(d.commonId))
        .then(unwrapResult)
        .then(() => {
          onUpdateColl(d.templateId)
        })
        .catch(() => {
          setLoading(false)
        })
    }, 500),
    []
  )

  // 获取模板详情
  const onUpdateColl = (id: string) => {
    dispatch(getTempalteDetailList(id))
      .then(unwrapResult)
      .then(async (details) => {
        const commonList = await dispatch(commonListAsync('2')).then(
          unwrapResult
        )
        setTemplateDetails({
          ...templateDetails,
          [id]: details,
          ['-1']: commonList,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }


  useEffect(() => {
    if (recipeCollapse?.length > 1)
      _.forEach(recipeCollapse, (id) => {
        if (!templateDetails[id]) {
          const template = templates.find((t) => t.id === id)
          setSelectedCategoryId(id)
          if (template) {
            dispatch(getTempalteDetailList(id))
              .then(unwrapResult)
              .then((details) => {
                setTemplateDetails({
                  ...templateDetails,
                  [id]: details,
                })
              })
          }
        }
      })
  }, [recipeCollapse])

  useEffect(() => {
    if (templateKeyword) {
      if (templates?.length) {
        const ids: any = templates?.map((v) => {
          return v?.id
        })
        setRecipeCollapse(ids)
      }
    } else {
      setRecipeCollapse([])
    }
  }, [templateKeyword, templates])

  return (
    <>
      <div >
        <Input
          value={templateKeyword}
          placeholder='请输入内容检索'
          onChange={(e) =>
            setTemplateKeyword((e.target.value || '').trim())
          }
          className={styles.searchInput}
          allowClear
        />
        <Spin spinning={loading}>
          <Collapse
            className={styles.templates}
            bordered={false}
            activeKey={recipeCollapse}
            expandIcon={(v) =>
              v.isActive ? (
                <CaretDownFilled className={styles.caretDown} />
              ) : (
                <CaretRightFilled className={styles.caretRight} />
              )
            }
            onChange={(ids) => {
              setRecipeCollapse(ids)
              _.forEach(ids, (id) => {
                if (!templateDetails[id]) {
                  const template = templates.find((t) => t.id === id)
                  if (template) {
                    dispatch(getTempalteDetailList(id))
                      .then(unwrapResult)
                      .then((details) => {
                        setTemplateDetails({
                          ...templateDetails,
                          [id]: details,
                        })
                      })
                  }
                }
              })
            }}
          >
            {templates.map((t) => (
              <Collapse.Panel
                key={t.id}
                header={
                  <div
                    className={styles.templateHeader}
                    style={{
                      color: templateKeyword
                        ? undefined
                        : selectedCategoryId === t.id
                          ? theme.c1
                          : undefined,
                      fontWeight: templateKeyword
                        ? undefined
                        : selectedCategoryId === t.id
                          ? 'bold'
                          : 'normal',
                    }}
                    onClick={() => {
                      setSelectedCategoryId(t.id)

                    }}
                  >
                    {t.categoryName}
                  </div>
                }
              >
                {templateDetails[t.id] &&
                  templateDetails[t.id]
                    .filter(
                        (d) =>
                          (!templateKeyword) ||
                          (isWubi == 1 ? (d.itemName.indexOf(templateKeyword) >= 0 || d.wubiCode.indexOf(templateKeyword) >= 0) : d.itemName.indexOf(templateKeyword) >= 0) ||
                          (isWubi == 1 ? d.wubiCode.indexOf(
                            templateKeyword.toUpperCase()
                          ) >= 0 : d.mnemonicCode.indexOf(
                            templateKeyword.toUpperCase()
                          ) >= 0)
                      )
                    .map((d, i) => (
                      <Row
                        key={d.id}
                        justify='space-between'
                        style={{
                          marginTop: 10,
                        }}
                      >
                        <Col span={20}>
                          <div
                            key={d.id}
                            onClick={() => {
                              setFormValues(d, t)
                              setSelectedCategoryId(t.id)
                            }}
                            style={{
                              color: theme.tc2,
                              fontSize: '1.125rem',
                              cursor: 'pointer',
                            }}
                          >
                            {i + 1}. {d.itemName}
                          </div>
                        </Col>
                        <Col
                          span={4}
                          className={styles.caretRight}
                        >
                          {d?.commonId && d?.commonId > 0 ? (
                            <LikeedIcon
                              className={styles.lickIcon}
                              onClick={(e) => {
                                setLoading(true)
                                e.stopPropagation()
                                liked(d)
                              }}
                            />
                          ) : (
                            <LikeIcon
                              className={styles.lickIcon}
                              onClick={(e) => {
                                setLoading(true)
                                e.stopPropagation()
                                like(d)
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    ))}
              </Collapse.Panel>
            ))}
          </Collapse>
        </Spin>
      </div>
      <SaveTemplateModal
        templates={templates?.filter((v) => v?.categoryName != '收藏')}
        medicalRecord={2}
        categoryName={
          templates.find((v) => v.id == selectedCategoryId)?.categoryName
        }
        detail={targetTemplate}
        visible={SaveTemplateModalVasible}
        onCancel={() => {
          setSaveTemplateModalVasible(false)
          cancelTemplate && cancelTemplate()
        }}
        onSave={() => {
          setSaveTemplateModalVasible(false)
          cancelTemplate && cancelTemplate()
          dispatch(getTempalteDetailList(selectedCategoryId))
            .then(unwrapResult)
            .then((details) => {
              setTemplateDetails({
                ...templateDetails,
                [selectedCategoryId]: details,
              })
            })
        }}
      />
    </>
  );
}

